export const APP_RESOLVER_PROVIDERS = [];
